import { omitBy } from 'lodash';

import { CalendarConfigSchema } from '../components/CalendarConfigCard/CalendarConfigCard';

export const getCalendarConfigPayload = (values: CalendarConfigSchema) => {
  if (Object.values(values).every((value) => value == null || value === '')) {
    return null;
  }

  const payloadCategories =
    values.appointmentTypeCategories?.map(({ id, appointmentTypeId }) => ({
      id,
      appointmentTypeId,
    })) || [];

  const payload = omitBy(
    {
      calendarId: values.calendarId,
      appointmentTypeCategories: payloadCategories,
    },
    (value) => value == null
  );

  return payload;
};
